import type { CarouselApi } from '~shared/shadcn/ui/carousel';

import {
  FAMILY_STUDENT_CAROUSEL_DIRECTION,
  type FamilyStudentCarouselDirection,
  type FamilyStudentCarouselPosition,
} from './student-by-family-mobile-carousel.types';

const EMPTY_FAMILY_STUDENT_CAROUSEL_POSITION: FamilyStudentCarouselPosition = {
  selectedIndex: 0,
  slideCount: 0,
  canScrollPrev: false,
  canScrollNext: false,
};

export function readFamilyStudentCarouselPosition(
  api: CarouselApi | undefined,
): FamilyStudentCarouselPosition {
  try {
    if (!api) {
      return EMPTY_FAMILY_STUDENT_CAROUSEL_POSITION;
    }

    return {
      selectedIndex: api.selectedScrollSnap(),
      slideCount: api.scrollSnapList().length,
      canScrollPrev: api.canScrollPrev(),
      canScrollNext: api.canScrollNext(),
    };
  } catch (error) {
    console.error('Failed to read the student list position', { error });
    throw error;
  }
}

export function scrollFamilyStudentCarousel(
  api: CarouselApi | undefined,
  direction: FamilyStudentCarouselDirection,
): void {
  try {
    if (!api) {
      return;
    }

    switch (direction) {
      case FAMILY_STUDENT_CAROUSEL_DIRECTION.PREV:
        api.scrollPrev();
        return;
      case FAMILY_STUDENT_CAROUSEL_DIRECTION.NEXT:
        api.scrollNext();
        return;
      default:
        return;
    }
  } catch (error) {
    console.error('Failed to move the student list', { direction, error });
    throw error;
  }
}
